/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { GET_ACES_CASE_PROGRAMS_PRODUCT_DELIVERIES_BY_CASE_ID } from './actionTypes';

/**
 * Updates the indicator of creation of details in the 'CaseProgramsProductDeliveries' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetAcesCaseProgramsProductDeliveriesByCaseIdReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(
    state,
    action,
    GET_ACES_CASE_PROGRAMS_PRODUCT_DELIVERIES_BY_CASE_ID
  );

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getAcesCaseProgramsProductDeliveriesByCaseIdErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(
    state,
    action,
    GET_ACES_CASE_PROGRAMS_PRODUCT_DELIVERIES_BY_CASE_ID
  );

const reducers = combineReducers({
  isFetchingGetAcesCaseProgramsProductDeliveriesByCaseId:
    isFetchingGetAcesCaseProgramsProductDeliveriesByCaseIdReducer,
  getAcesCaseProgramsProductDeliveriesByCaseIdError:
    getAcesCaseProgramsProductDeliveriesByCaseIdErrorReducer,
});

export default { reducers };
